<template>
  <parent>
    <loading-page v-if="loading" />
    <div
      v-else
      class="cache-policies-editor h-100"
    >
      <validation-observer
        ref="rules"
        v-slot="{ invalid }"
      >
        <form-wrapper full-width>
          <template v-slot:body>
            <paper>
              <template v-slot:title>
                <p class="mb-0">
                  Info
                </p>
              </template>
              <div class="px-2 col-12 col-lg-6 m-auto">
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  rules="required"
                  class="w-100 mb-1"
                >
                  <input-field
                    name="name"
                    label="Name"
                    label-position="top"
                    :error="errors.length ? errors[0] : null"
                  >
                    <b-form-input
                      id="name"
                      v-model="cachePolicy.name"
                      placeholder="Add name here..."
                      :state="errors.length > 0 ? false : null"
                    />
                  </input-field>
                </validation-provider>

                <b-form-group
                  label="Comment"
                >
                  <b-form-input
                    id="comment"
                    v-model="cachePolicy.comment"
                    placeholder="Add comment here..."
                  />
                </b-form-group>
              </div>
            </paper>

            <paper>
              <template v-slot:title>
                <p class="mb-0">
                  TTL Settings
                </p>
              </template>
              <div class="d-flex flex-wrap col-12 py-3">
                <div class="px-2 col-12 col-lg-6 m-auto">
                  <h6 class="text-main">
                    Server TTL Settings
                  </h6>

                  <validation-provider
                    #default="{ errors }"
                    name="Minimum TTL"
                    rules="positive"
                  >
                    <input-field
                      label="Minimum TTL"
                      label-position="top"
                      :info="messages.minimumTTL"
                      :error="errors.length ? errors[0] : null"
                      @openInfo="
                        showInfo(
                          messages.minimumTTL.title,
                          messages.minimumTTL.message,
                        )
                      "
                    >
                      <b-form-input
                        v-model="cachePolicy.minimumTTL"
                        type="number"
                      />
                    </input-field>
                  </validation-provider>

                  <validation-provider
                    #default="{ errors }"
                    name="Maximum TTL"
                    rules="positive"
                  >
                    <input-field
                      name="maximumTTL"
                      label="Maximum TTL"
                      label-position="top"
                      :error="errors.length ? errors[0] : null"
                      :info="messages.maximumTTL"
                      @openInfo="
                        showInfo(
                          messages.maximumTTL.title,
                          messages.maximumTTL.message,
                        )
                      "
                    >
                      <b-form-input
                        id="maximumTTL"
                        v-model="cachePolicy.maximumTTL"
                        type="number"
                      />
                    </input-field>
                  </validation-provider>

                  <validation-provider
                    #default="{ errors }"
                    name="Default TTL"
                    rules="positive"
                  >
                    <input-field
                      name="defaultTTL"
                      label="Default TTL"
                      label-position="top"
                      :error="errors.length ? errors[0] : null"
                      :info="messages.defaultTTL"
                      @openInfo="
                        showInfo(
                          messages.defaultTTL.title,
                          messages.defaultTTL.message,
                        )
                      "
                    >
                      <b-form-input
                        id="defaultTTL"
                        v-model="cachePolicy.defaultTTL"
                        type="number"
                      />
                    </input-field>
                  </validation-provider>

                  <b-button
                    class="mb-5"
                    variant="border border-primary text-primary"
                    @click="serverTTLDefaultValues"
                  >
                    Set to default
                  </b-button>
                </div>
                <div class="px-2 col-12 col-lg-6 m-auto">
                  <h6 class="text-main">
                    Browser TTL Settings
                  </h6>

                  <validation-provider
                    #default="{ errors }"
                    name="Broswer Minimum TTL"
                    rules="positive"
                  >
                    <input-field
                      name="broswerminimumTtl"
                      label="Minimum TTL"
                      label-position="top"
                      :error="errors.length ? errors[0] : null"
                      :info="messages.browserMinimumTTL"
                      @openInfo="
                        showInfo(
                          messages.browserMinimumTTL.title,
                          messages.browserMinimumTTL.message,
                        )
                      "
                    >
                      <b-form-input
                        id="minimumTTL"
                        v-model="cachePolicy.browserMinimumTTL"
                        type="number"
                      />
                    </input-field>
                  </validation-provider>

                  <validation-provider
                    #default="{ errors }"
                    name="Broswer Maximum TTL"
                    rules="positive"
                  >
                    <input-field
                      name="browserMaximumTTL"
                      label="Maximum TTL"
                      label-position="top"
                      :info="messages.browserMaximumTTL"
                      :error="errors.length ? errors[0] : null"
                      @openInfo="
                        showInfo(
                          messages.browserMaximumTTL.title,
                          messages.browserMaximumTTL.message,
                        )
                      "
                    >
                      <b-form-input
                        id="browserMaximumTTL"
                        v-model="cachePolicy.browserMaximumTTL"
                        type="number"
                      />
                    </input-field>
                  </validation-provider>

                  <validation-provider
                    #default="{ errors }"
                    name="Broswer Default TTL"
                    rules="positive"
                  >
                    <input-field
                      name="browserDefaultTTL"
                      label="Default TTL"
                      label-position="top"
                      :error="errors.length ? errors[0] : null"
                      :info="messages.browserDefaultTTL"
                      @openInfo="
                        showInfo(
                          messages.browserDefaultTTL.title,
                          messages.browserDefaultTTL.message,
                        )
                      "
                    >
                      <b-form-input
                        id="browserDefaultTTL"
                        v-model="cachePolicy.browserDefaultTTL"
                        type="number"
                      />
                    </input-field>
                  </validation-provider>

                  <div class="d-flex">
                    <b-form-checkbox
                      v-model="cachePolicy.addBrowserCache"
                      switch
                    />
                    <div class="mt-1">

                      <span class="">Browser cache</span>
                      <a
                        @click="
                          showInfo(messages.addBrowserCache.title, messages.addBrowserCache.message)
                        "
                      >
                        <GjIcon
                          class="ml-1"
                          name="Info"
                        />
                      </a>
                    </div>
                  </div>

                  <b-button
                    class="mt-2"
                    variant="border border-primary text-primary"
                    @click="browserTTLDefaultValues"
                  >
                    Set to default
                  </b-button>
                </div>
              </div>
            </paper>

            <paper>
              <template v-slot:title>
                <div>
                  <p>
                    Cache key contents
                  </p>
                  <span
                    class="text-regular"
                  >The cache key includes the headers, cookies, and query
                    strings in the cache policy, as follows:</span>
                </div>
              </template>
              <div class="px-2 col-12 col-lg-6 m-auto">
                <div class="d-flex full-form">
                  <div class="w-100">
                    <label for="headerOptions">Headers</label>
                    <span
                      class="subtitle bold"
                    >Choose headers to add to the cache key</span>
                    <custom-select
                      v-if="cachePolicyModel.headerOptions"
                      id="headerOptions"
                      v-model="cachePolicy.headerPolicyId"
                      :options="getOptions(cachePolicyModel.headerOptions)"
                    />
                    <template v-if="cachePolicy.headerPolicyId !== 0">
                      <div class="d-flex add-new">
                        <b-form-input
                          id="headerPolicyValue"
                          v-model="headerPolicyValue"
                          :class="{ error: invalidString }"
                          @click="invalidString = false"
                          @keyup.enter="addHeader"
                        />
                        <b-button
                          variant="bg-white"
                          @click="addHeader"
                          @keyup.enter="addHeader"
                        >
                          Add Header
                        </b-button>
                      </div>
                      <div
                        v-if="

                          headers[cachePolicy.headerPolicyId] &&
                            headers[cachePolicy.headerPolicyId].length > 0 &&
                            cachePolicy.headerPolicyId !== 1"
                      >

                        <template
                          v-for="(header, index) in headers[
                            cachePolicy.headerPolicyId
                          ]"
                        >
                          <b-button
                            :key="header"
                            variant="bg-white"
                            class="margin-5 bg-danger"
                          >
                            {{ header }}
                            <a @click="removeHeadersArrayItem(index)">
                              <GjIcon
                                class="icon-right"
                                name="Close"
                              />
                            </a>
                          </b-button>
                        </template>
                      </div>
                    </template>
                  </div>
                  <a
                    @click="
                      showInfo(messages.headers.title, messages.headers.message)
                    "
                  >
                    <GjIcon
                      class="icon-right mt-5"
                      name="Info"
                    />
                  </a>
                </div>

                <div class="d-flex full-form">
                  <div class="w-100">
                    <label for="cookiesOptions">Cookies</label>
                    <span
                      class="subtitle bold"
                    >Choose cookies to add to the cache key</span>
                    <custom-select
                      v-if="cachePolicyModel.cookieOptions"
                      id="cookiesOptions"
                      v-model="cachePolicy.cookiePolicyId"
                      :options="getOptions(cachePolicyModel.cookieOptions)"
                    />
                    <template
                      v-if="
                        cachePolicy.cookiePolicyId !== 0 &&
                          cachePolicy.cookiePolicyId !== 1
                      "
                    >
                      <div class="d-flex add-new">
                        <b-form-input
                          id="cookiePolicyValue"
                          v-model="cookiePolicyValue"
                          :class="{ error: invalidCookieString }"
                          @click="invalidCookieString = false"
                          @keyup.enter="addCookie"
                        />
                        <b-button
                          variant="bg-white"
                          @click="addCookie"
                        >
                          Add Cookie
                        </b-button>
                      </div>
                      <div
                        v-if="
                          cookies[cachePolicy.cookiePolicyId] &&
                            cookies[cachePolicy.cookiePolicyId].length > 0 &&
                            cachePolicy.cookiePolicyId !== 1
                        "
                      >
                        <template
                          v-for="(cookie, index) in cookies[
                            cachePolicy.cookiePolicyId
                          ]"
                        >
                          <b-button
                            :key="cookie"
                            class="margin-5"
                            variant="bg-white"
                          >
                            {{ cookie }}
                            <a @click="removeCookiesArrayItem(index)">
                              <GjIcon
                                class="icon-right"
                                name="Close"
                              />
                            </a>
                          </b-button>
                        </template>
                      </div>
                    </template>
                  </div>
                  <a
                    @click="
                      showInfo(messages.cookies.title, messages.cookies.message)
                    "
                  >
                    <GjIcon
                      class="icon-right form__icon"
                      name="Info"
                    />
                  </a>
                </div>

                <div class="d-flex full-form">
                  <div class="w-100">
                    <label for="queryStringOptions">Query strings</label>
                    <span
                      class="subtitle bold"
                    >Choose query strings to add to the cache key</span>
                    <custom-select
                      v-if="cachePolicyModel.queryStringOptions"
                      id="queryStringOptions"
                      v-model="cachePolicy.queryStringPolicyId"
                      :options="getOptions(cachePolicyModel.queryStringOptions)"
                    />
                    <template
                      v-if="
                        cachePolicy.queryStringPolicyId !== 0 &&
                          cachePolicy.queryStringPolicyId !== 1
                      "
                    >
                      <div class="d-flex add-new">
                        <b-form-input
                          id="queryStringPolicyValue"
                          v-model="queryStringPolicyValue"
                          :class="{ error: invalidQueryString }"
                          @click="invalidQuweyString = false"
                          @keyup.enter="addQueryString"
                        />
                        <b-button
                          variant="bg-white"
                          @click="addQueryString"
                        >
                          Add Query String
                        </b-button>
                      </div>
                      <div
                        v-if="
                          queryStrings[cachePolicy.queryStringPolicyId] &&
                            queryStrings[cachePolicy.queryStringPolicyId].length > 0 &&
                            cachePolicy.queryStringPolicyId !== 1
                        "
                      >
                        <template
                          v-for="(queryString, index) in queryStrings[
                            cachePolicy.queryStringPolicyId
                          ]"
                        >
                          <b-button
                            :key="queryString"
                            class="margin-5"
                            variant="bg-white"
                          >
                            {{ queryString }}
                            <a @click="removeQueryStringsArrayItem(index)">
                              <GjIcon
                                class="icon-right"
                                name="Close"
                              />
                            </a>
                          </b-button>
                        </template>
                      </div>
                    </template>
                  </div>
                  <a
                    @click="
                      showInfo(
                        messages.queryStrings.title,
                        messages.queryStrings.message,
                      )
                    "
                  >
                    <GjIcon
                      class="icon-right form__icon"
                      name="Info"
                    />
                  </a>
                </div>
              </div>
            </paper>
          </template>
          <template v-slot:footer>
            <b-button
              variant="bg-white"
              @click="$emit('close')"
            >
              Cancel
            </b-button>
            <button-loading
              v-if="details"
              :spinning="updatingPolicy"
              variant="bg-primary"
              class="ml-16"
              :disabled="invalid || tagsOk"
              @click="onEdit"
            >
              Update
            </button-loading>
            <button-loading
              v-if="!details"
              :spinning="addingPolicy"
              variant="primary"
              class="ml-16"
              :disabled="invalid || tagsOk"
              @click="onCreate"
            >
              Create
            </button-loading>
          </template>
        </form-wrapper>
      </validation-observer>

      <info
        v-if="openInfo"
        :title="infoTitle"
        :message="infoMessage"
        @close="openInfo = false"
      />
    </div>
  </parent>
</template>
<script>
import InputField from '@/components/form/InputField.vue'
import Paper from '@/components/paper/Paper.vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import messages from '../../messages'

import redirectError from '@/services/redirectError'

export default {
  name: 'CachePoliciesFrom',
  components: {
    InputField,
    ValidationProvider,
    ValidationObserver,
    Paper,
  },
  props: {
    row: {
      default: null,
      type: Object,
    },
    details: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      messages,
      required,
      openInfo: false,
      infoTitle: '',
      infoMessage: '',
      selected: null,
      cachePolicyModel: {},
      headerPolicyValue: '',
      headers: [[], []],
      invalidString: false,
      cookiePolicyValue: '',
      cookies: [[], [], [], []],
      invalidCookieString: false,
      queryStringPolicyValue: '',
      queryStrings: [[], [], [], []],
      invalidQueryString: false,
    }
  },
  computed: {
    addingPolicy() {
      return this.$store.state.cachePolicies.addingPolicy
    },
    updatingPolicy() {
      return this.$store.state.cachePolicies.updatingPolicy
    },
    cachePolicy() {
      return this.$store.state.cachePolicies.cachePolicy
    },
    loading() {
      return this.$store.state.cachePolicies.gettingPolicy
    },
    queryStringsOk() {
      if (
        this.cachePolicy.queryStringPolicyId !== 0
    && this.cachePolicy.queryStringPolicyId !== 1
    && this.queryStrings[this.cachePolicy.queryStringPolicyId]
      ) {
        return this.queryStrings[this.cachePolicy.queryStringPolicyId].length === 0
      }

      return false
    },
    headersOk() {
      if (this.cachePolicy.headerPolicyId === 1) {
        return this.headers[1].length === 0
      }
      return false
    },
    cookiesOk() {
      if (
        this.cachePolicy.cookiePolicyId !== 1
    && this.cachePolicy.cookiePolicyId !== 0
    && this.cookies[this.cachePolicy.cookiePolicyId]
      ) {
        return this.cookies[this.cachePolicy.cookiePolicyId].length === 0
      }

      return false
    },
    tagsOk() {
      return this.headersOk || this.cookiesOk || this.queryStringsOk
    },
  },
  created() {
    if (this.details) {
      this.cachePolicyModel = this.cachePolicy
      this.cookies[this.cachePolicy.cookiePolicyId] = this.cachePolicy.cookies
      this.headers[this.cachePolicy.headerPolicyId] = this.cachePolicy.headers
      this.queryStrings[
        this.cachePolicy.queryStringPolicyId
      ] = this.cachePolicy.queryStrings
    } else {
      this.getCachePolicy()
    }
  },
  methods: {
    onCreate() {
      this.validation()
        .then(() => {
          const localCachePolicy = {
            id: this.cachePolicy.id,
            name: this.cachePolicy.name,
            comment: this.cachePolicy.comment,
            minimumTTL: this.cachePolicy.minimumTTL,
            maximumTTL: this.cachePolicy.maximumTTL,
            browserMinimumTTL: this.cachePolicy.browserMinimumTTL,
            browserMaximumTTL: this.cachePolicy.browserMaximumTTL,
            browserDefaultTTL: this.cachePolicy.browserDefaultTTL,
            addBrowserCache: this.cachePolicy.addBrowserCache,
            defaultTTL: this.cachePolicy.defaultTTL,
            headerPolicyId: this.cachePolicy.headerPolicyId,
            headers: this.headers[this.cachePolicy.headerPolicyId],
            cookiePolicyId: this.cachePolicy.cookiePolicyId,
            cookies: this.cookies[this.cachePolicy.cookiePolicyId],
            queryStringPolicyId: this.cachePolicy.queryStringPolicyId,
            queryStrings: this.queryStrings[
              this.cachePolicy.queryStringPolicyId
            ],
          }
          this.addCachePolicy(localCachePolicy)
        })
        .catch(() => {})
    },
    getCachePolicy() {
      this.$store
        .dispatch('cachePolicies/getCachePolicy', 0)
        .then(res => {
          this.cachePolicyModel = res.data.result
        })
        .catch(err => redirectError(err, this.$router, this.$route.path))
    },
    addCachePolicy(localCachePolicy) {
      this.$store
        .dispatch('cachePolicies/addCachePolicy', localCachePolicy)
        .then(() => {
          this.successToast('Cache policy was added')
          this.$emit('close')
          this.$emit('onCreate')
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while creating policy.')
        })
    },
    onEdit() {
      this.validation()
        .then(() => {
          const localCachePolicy = {
            id: this.cachePolicy.id,
            name: this.cachePolicy.name,
            comment: this.cachePolicy.comment,
            minimumTTL: this.cachePolicy.minimumTTL,
            maximumTTL: this.cachePolicy.maximumTTL,
            defaultTTL: this.cachePolicy.defaultTTL,
            browserMinimumTTL: this.cachePolicy.browserMinimumTTL,
            browserMaximumTTL: this.cachePolicy.browserMaximumTTL,
            browserDefaultTTL: this.cachePolicy.browserDefaultTTL,
            addBrowserCache: this.cachePolicy.addBrowserCache,
            headerPolicyId: this.cachePolicy.headerPolicyId,
            headers: this.headers[this.cachePolicy.headerPolicyId],
            cookiePolicyId: this.cachePolicy.cookiePolicyId,
            cookies: this.cookies[this.cachePolicy.cookiePolicyId],
            queryStringPolicyId: this.cachePolicy.queryStringPolicyId,
            queryStrings: this.queryStrings[
              this.cachePolicy.queryStringPolicyId
            ],
          }
          this.$emit('edit', localCachePolicy)
        })
        .catch(() => {})
    },
    validation() {
      return new Promise((resolve, reject) => {
        this.$refs.rules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    addHeader() {
      const re = /^[a-zA-Z_-]+$/
      const term = this.headerPolicyValue
      if (re.test(term)) {
        this.headers[this.cachePolicy.headerPolicyId].push(term)
        this.headerPolicyValue = ''
      } else {
        this.invalidString = true
      }
    },
    removeHeadersArrayItem(index) {
      this.headers[this.cachePolicy.headerPolicyId].splice(index, 1)
    },
    addCookie() {
      const re = /^[a-zA-Z_-]+$/
      const term = this.cookiePolicyValue
      if (re.test(term)) {
        this.cookies[this.cachePolicy.cookiePolicyId].push(term)
        this.cookiePolicyValue = ''
      } else {
        this.invalidCookieString = true
      }
    },
    removeCookiesArrayItem(index) {
      this.cookies[this.cachePolicy.cookiePolicyId].splice(index, 1)
    },
    addQueryString() {
      const re = /^[a-zA-Z_-]+$/
      const term = this.queryStringPolicyValue
      if (re.test(term)) {
        this.queryStrings[this.cachePolicy.queryStringPolicyId].push(term)
        this.queryStringPolicyValue = ''
      } else {
        this.invalidQueryString = true
      }
    },
    removeQueryStringsArrayItem(index) {
      this.queryStrings[this.cachePolicy.queryStringPolicyId].splice(index, 1)
    },
    showInfo(title, info) {
      this.openInfo = true
      this.infoTitle = title
      this.infoMessage = info
    },
    serverTTLDefaultValues() {
      this.cachePolicy.minimumTTL = 0
      this.cachePolicy.maximumTTL = 0
      this.cachePolicy.defaultTTL = 0
    },
    browserTTLDefaultValues() {
      this.cachePolicy.browserMinimumTTL = 1
      this.cachePolicy.browserMaximumTTL = 3600
      this.cachePolicy.browserDefaultTTL = 0
      this.cachePolicy.addBrowserCache = false
    },

  },
}
</script>
<style lang="scss" scoped>

.subtitle {
  display: block;
  font-size: 12px;
  color: #667c99;
  font-weight: 500;
  margin-bottom: 6px;
}
.add-new {
  margin-top: 14px;

}
.form__icon {
  margin-top: 55px;
}

.margin-5 {
  margin: 0 5px 5px 0;
}
</style>
